<svelte:options accessors/>
<script>
    import {createEventDispatcher} from "svelte";
    import NauiInput from "../../../naui/atoms/NauiInput.svelte";
    import NauiFloatingAction from "../../../naui/components/NauiFloatingAction.svelte";
    import NauiButton from "../../../naui/atoms/NauiButton.svelte";
    import InputCupo from "./InputCupo.svelte";

    const events = createEventDispatcher();

    export let data;

    function sendData() {
        events('submit', data);
    }
</script>
<div>
    <div class="py-15">
        <table class="naui-table w-max-content">
            <thead>
                <tr>
                    <th colspan="2">
                        <div>Cupos del mes</div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <InputCupo bind:item={data.cupos.transporte} label="transporte"/>
                <InputCupo bind:item={data.cupos.embalaje} label="embalaje"/>
                <InputCupo bind:item={data.cupos.otros} label="otros"/>
                <tr>
                    <td>
                        <div>Anticipos bodegas</div>
                    </td>
                    <td>
                        <div>
                            <NauiInput bind:value={data.anticipos_bodega} id="anticipos-input" type="currency" label="" />
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <NauiFloatingAction>
        <NauiButton caption="GUARDAR CAMBIOS"
                    color="accent"
                    mode="solid"
                    on:click={sendData}/>
    </NauiFloatingAction>
</div>